<ces-time-series-detail
  [title]="measureName()"
  [externalLinkUrl]="measureDetailUrl()"
  [frequencyTag]="measureFrequency() || null"
  [breadcrumbTrail]="breadcrumbTrail()"
  [columnDefs]="columnDefs()"
  [datasource]="datasource"
  [isLoading]="isLoading()"
  [loadError]="loadError()"
  [isReady]="gridReady()"
  [isEmpty]="isEmpty()"
  [clipboardColumnType]="clipboardColumnType"
  (copyValues)="copyValues()"
  (cellsCopied)="onCellsCopied($event)"
  (windowChanged)="onUserRefresh()"
  (windowFromUrl)="onUrlWindow()">
  <app-measure-column-toggle slot="column-toggle" [value]="visibleColumns()" (visibilityChange)="onColumnVisibilityChange($event)" />
</ces-time-series-detail>

@if (canWrite() === true && hasDraft()) {
  <ces-bottom-actions
    [cancelLabel]="'common.buttons.cancel' | transloco"
    [validateLabel]="'common.buttons.saveChanges' | transloco"
    [validateDisabled]="isSaving()"
    (discard)="cancelDraft()"
    (validate)="saveDraft()" />
}
